jQuery(document).ready(function() {

    var maxLength = 250;
    var description = jQuery(".product-detail__form__description .description");
    var fullHtml = description.html();
    var wrapper = jQuery('<div>' + fullHtml + '</div>');
    var shortHtml = "";
    var longHtml = "";
    var bodyLang = document.body.getAttribute('lang'); // check for lang attribute on body tag
    var showMoreText = bodyLang === 'fr' ? "afficher plus" : "show more";
    var showLessText = bodyLang === 'fr' ? "afficher moins" : "show less";

    var htmlWords = wrapper.html().split(/(\s+)/);
    var count = 0;
    var isShort = true;

    htmlWords.forEach(function(word) {
        var wordLength = jQuery("<div>").html(word).text().length;

        if (isShort && (count + wordLength) > maxLength) {
            isShort = false;
        }

        if (isShort) {
            shortHtml += word;
            count += wordLength;
        } else {
            longHtml += word;
        }
    });

    if (!isShort) {
        var finalHtml = shortHtml +
            '<span class="moreellipses">...&nbsp;</span>' +
            '<span class="morecontent"><span>' + longHtml + '</span> <a href="" class="morelink">' + showMoreText + '</a></span>';

        description.html(finalHtml);
    }

    jQuery(".morelink").click(function() {
        if (jQuery(this).hasClass("less")) {
            jQuery(this).removeClass("less");
            jQuery(this).html(showMoreText);
        } else {
            jQuery(this).addClass("less");
            jQuery(this).html(showLessText);
        }
        jQuery(this).parent().prev().toggle();
        jQuery(this).prev().toggle();
        return false;
    });

    // Get the images container
    var imagesContainer = document.querySelector('.product-detail__form__description .product-images');

    // Fetch all the images
    var allImages = imagesContainer ? imagesContainer.querySelectorAll('img') : [];

    // If the container has more than one image
    if (allImages.length > 1) {
        // Convert NodeList to Array to use slice
        var imagesToHide = Array.from(allImages).slice(1);

        imagesToHide.forEach(function(img) {
            img.classList.add('hide');
        });

        // Create the show more/less toggle button
        var toggleBtn = document.createElement('span');
        toggleBtn.innerText = showMoreText;
        toggleBtn.classList.add('show-toggle');

        toggleBtn.addEventListener('click', function() {
            imagesToHide.forEach(function(img) {
                if (img.classList.contains('hide')) {
                    img.classList.remove('hide');
                } else {
                    img.classList.add('hide');
                }
            });

            // Toggle button text and state based on a class
            if (toggleBtn.classList.contains('less')) {
                toggleBtn.innerText = showMoreText;
                toggleBtn.classList.remove('less');
            } else {
                toggleBtn.innerText = showLessText;
                toggleBtn.classList.add('less');
            }
        });

        // Append the toggle button after the images container
        imagesContainer.after(toggleBtn);
    }

});
